// extracted by mini-css-extract-plugin
module.exports = {"header-size":"learn_header-size__399g0","gray-box":"learn_gray-box__3FI9O"};